import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

function useCustomMediaQuery(): {
  isMobileView: boolean;
  isVerticalTabletView: boolean;
  isHorizontalTabletView: boolean;
  isDesktopView: boolean;
} {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.between("xs", "sm"), {
    noSsr: true,
  });
  const isVerticalTabletView = useMediaQuery(
    theme.breakpoints.between("sm", "md"),
    {
      noSsr: true,
    }
  );
  const isHorizontalTabletView = useMediaQuery(
    theme.breakpoints.between("md", "lg"),
    {
      noSsr: true,
    }
  );
  const isDesktopView = useMediaQuery(theme.breakpoints.up("lg"), {
    noSsr: true,
  });
  return {
    isMobileView,
    isVerticalTabletView,
    isHorizontalTabletView,
    isDesktopView,
  };
}

export default useCustomMediaQuery;
